// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuetify from 'vuetify'
import VueLodash from 'vue-lodash'
import moment from 'vue-moment'
import VueCurrencyFilter from 'vue-currency-filter'
import Vuebar from 'vuebar'
import VueResize from 'vue-resize'
import store from '@/store'
import {i18n, loadLanguageAsync} from '@/library/locale/i18n'
import config from '@/config'
import SDKLoader from '@/library/geolocation/sdkLoader.js'

Vue.filter('lowercase', function (value) {
  if (!value) return ''
  return value.toLowerCase()
})

Vue.use(VueResize)
Vue.use(VueLodash)
Vue.use(moment)
Vue.use(Vuetify)
Vue.use(Vuebar)
Vue.use(VueCurrencyFilter, {
  symbol: (config.app.CURRENCY),
  thousandsSeparator: ',',
  fractionCount: 2,
  fractionSeparator: '.',
  symbolPosition: 'front',
  symbolSpacing: false
})

const isDev = process.env.NODE_ENV === 'development'
const hasDebug = sessionStorage.geolocationDebug
const isMobileApp = window.ctsautoconf.MOBILE_LS

Vue.prototype.$geolocationDebug = isDev || hasDebug
if (isDev) sessionStorage.geolocationDebug = true

Vue.config.productionTip = false
if (!isMobileApp) {
  const geolocationConfig = {
    geolocationProvider: window.ctsautoconf.GEOLOCATION.PROVIDER
  }
  const geolocationSDKLoader = new SDKLoader(geolocationConfig.geolocationProvider, Vue.prototype.$geolocationDebug)
  geolocationSDKLoader.loadSDK().then((sdk) => {
    if (Vue.prototype.$geolocationDebug) console.log('[SDK loader] SDK ready to use.')
  }).catch((err) => {
    if (Vue.prototype.$geolocationDebug) console.error('[SDK loader] Failed to load SDK:', err)
  })
}

// function hasQueryParams (route) {
//   return !!Object.keys(route.query).length
// }
//
// router.beforeEach((to, from, next) => {
//   if (!hasQueryParams(to) && hasQueryParams(from)) {
//     next({name: to.name, query: from.query})
//   } else {
//     next()
//   }
// })

/* eslint-disable no-new */

new Vue({
  el: '#app',
  store,
  router,
  i18n,
  components: { App },
  template: '<App/>',
  created: function () {
    loadLanguageAsync()
  }
})



// WEBPACK FOOTER //
// ./src/main.js